import { API } from "aws-amplify";
import {
  resolveCorporateFacilityIdForRequest,
  queryWithSelectedCorporateFacId,
} from "./facilityLambdaHelpers";

export const DEFAULT_CALENDAR_SERVICE_CATEGORY = "Activity Service";

/** Synthetic react-select option — Calendar import Service dropdown only. */
export const CALENDAR_SERVICE_ALL_VALUE = "__calendar_service_all__";
export const CALENDAR_SERVICE_ALL_OPTION = {
  value: CALENDAR_SERVICE_ALL_VALUE,
  label: "All",
};

export const isCalendarServiceAllOption = (option) =>
  String(option?.value ?? "") === CALENDAR_SERVICE_ALL_VALUE;

export const isCalendarServiceAllSelected = (selection) =>
  Array.isArray(selection) && selection.some(isCalendarServiceAllOption);

export const buildCalendarServiceSelectOptions = (categoryOptions) => [
  CALENDAR_SERVICE_ALL_OPTION,
  ...(Array.isArray(categoryOptions) ? categoryOptions : []),
];

/** Normalize API category entries (string or object) into react-select options. */
export const normalizeCalendarCategoryOption = (category) => {
  if (category == null) return null;
  if (typeof category === "string") {
    const label = category.trim();
    return label ? { value: label, label } : null;
  }
  if (typeof category === "object") {
    const label = String(
      category.label
        ?? category.Label
        ?? category.name
        ?? category.Name
        ?? category.serviceName
        ?? category.ServiceName
        ?? category.value
        ?? category.Value
        ?? "",
    ).trim();
    return label ? { value: label, label } : null;
  }
  return null;
};

export const buildCalendarCategoryOptions = (categorieslist) => {
  if (!Array.isArray(categorieslist)) return [];
  const seen = new Set();
  const options = [];
  categorieslist.forEach((category) => {
    const option = normalizeCalendarCategoryOption(category);
    if (!option || seen.has(option.value)) return;
    seen.add(option.value);
    options.push(option);
  });
  return options;
};

/** Match saved multi-select values to current option list. */
export const resolveSavedCalendarCategories = (savedSelections, options) => {
  if (!Array.isArray(options) || options.length === 0) {
    return [];
  }
  if (
    Array.isArray(savedSelections)
    && savedSelections.some((sel) => isCalendarServiceAllOption(sel) || String(sel?.value ?? sel ?? "") === CALENDAR_SERVICE_ALL_VALUE)
  ) {
    return [CALENDAR_SERVICE_ALL_OPTION];
  }
  if (!Array.isArray(savedSelections)) {
    return [];
  }
  const byValue = new Map(options.map((opt) => [String(opt.value).toLowerCase(), opt]));
  const byLabel = new Map(options.map((opt) => [String(opt.label).toLowerCase(), opt]));
  const resolved = [];
  const seen = new Set();
  savedSelections.forEach((sel) => {
    const raw = String(sel?.value ?? sel?.label ?? sel ?? "").trim().toLowerCase();
    if (!raw) return;
    const match = byValue.get(raw) ?? byLabel.get(raw);
    if (!match || seen.has(match.value)) return;
    seen.add(match.value);
    resolved.push(match);
  });
  return resolved;
};

/** Default Service filter: Activity Service (flexible match), else second list item (legacy QuickPrints). */
export const pickDefaultActivityServiceCategory = (options) => {
  if (!Array.isArray(options) || options.length === 0) return null;

  const exact = options.find(
    (item) => String(item?.label ?? item?.value ?? "").trim().toLowerCase()
      === DEFAULT_CALENDAR_SERVICE_CATEGORY.toLowerCase(),
  );
  if (exact) return exact;

  const activityMatch = options.find((item) => {
    const text = String(item?.label ?? item?.value ?? "").trim().toLowerCase();
    return text.includes("activity") && text.includes("service");
  });
  if (activityMatch) return activityMatch;

  const looseActivity = options.find((item) => {
    const text = String(item?.label ?? item?.value ?? "").trim().toLowerCase();
    return text === "activity" || text === "activities" || /^activity\b/.test(text);
  });
  if (looseActivity) return looseActivity;

  if (options.length > 1) return options[1];
  return options[0] ?? null;
};

/** Calendar Service multi-select: All is exclusive; empty selection defaults to Activity. */
export const normalizeCalendarServiceSelection = (nextSelection, categoryOptions) => {
  const options = Array.isArray(categoryOptions) ? categoryOptions : [];
  const defaultActivity = pickDefaultActivityServiceCategory(options);
  const selection = Array.isArray(nextSelection) ? nextSelection : [];

  if (selection.some(isCalendarServiceAllOption)) {
    return [CALENDAR_SERVICE_ALL_OPTION];
  }

  const withoutAll = selection.filter((opt) => !isCalendarServiceAllOption(opt));
  if (withoutAll.length === 0) {
    return defaultActivity ? [defaultActivity] : [];
  }

  return withoutAll;
};

/** API list for /dailyactivities/listAll — empty when All is selected (omit categories filter). */
export const buildCalendarCategoriesApiList = (selectedCategories) => {
  if (isCalendarServiceAllSelected(selectedCategories)) return [];
  return (Array.isArray(selectedCategories) ? selectedCategories : [])
    .map((item) => item?.value)
    .filter((value) => value && value !== CALENDAR_SERVICE_ALL_VALUE);
};

export const getCalendarCategories=async(throwOnError=false)=>{

    try {
      // Fixed: was resolveLambdaFacilityId() — see docs/signage/corporate-facility-id-fix.md.
      const corporateFacilityId = await resolveCorporateFacilityIdForRequest();
      const response = await API.get('lambda', '/services-types/getCategories', {
        queryStringParameters: queryWithSelectedCorporateFacId({}, corporateFacilityId),
      });
    //  console.log("operation Successfull for Calendar categories list"+JSON.stringify(response));
     if(response.Success===true)
     {
        // console.log("Calendar categories are",JSON.stringify(response.Content))
        return response.Content;
     }
    return []
    } catch (error) {
      console.log("Something went wrong while Fetching Calendar TypesList"+error.message);
      if(throwOnError) throw error;
      return [];
  }
  };



